import { dateHelpers } from '@nocowanie/core/helpers';
import { GridWrapper } from '@nocowanie/common-ui/components/atoms/grid-wrapper';

import { SearchEngineWrapper } from '@app/components/molecules/search-engine-wrapper';
import { AppPromotionBanner } from '@app/components/organisms/app-promotion-banner';
import { DestinationSuggestions } from '@app/components/organisms/destination-suggestions';
import { FeaturedAccommodations } from '@app/components/organisms/featured-accommodations';
import { FeaturedCountries } from '@app/components/organisms/featured-countries';
import { Hero } from '@app/components/organisms/hero';
import { HorizontalBanner } from '@app/components/organisms/horizontal-banner';
import { Newsletter } from '@app/components/organisms/newsletter';
import { SeoLinksHomepage } from '@app/components/organisms/seo-links-homepage';
import { Support } from '@app/components/organisms/support';

export const Home = () => {
    return (
        <>
            <Hero />
            <GridWrapper
                gridTemplateColumns={{ base: 'minmax(0, 1fr)' }}
                rowGap={{
                    base: 'sectionGap',
                    md: 'sectionGapDesktop',
                }}
            >
                <SearchEngineWrapper
                    isMobileCompactVersion={false}
                    isV7SearchEngineVersion={true}
                    pos={'relative'}
                    marginTop={'-44px'}
                    initialSearchData={{
                        dates: {
                            checkInDate: dateHelpers.defaultCheckInDate(),
                            checkOutDate: dateHelpers.defaultCheckOutDate(),
                        },
                    }}
                />
                <HorizontalBanner />
                <DestinationSuggestions />
                <FeaturedAccommodations />
                <FeaturedCountries />
            </GridWrapper>

            <AppPromotionBanner />

            <GridWrapper
                gridTemplateColumns={{ base: 'minmax(0, 1fr)' }}
                rowGap={{
                    base: 'sectionGap',
                    md: 'sectionGapDesktop',
                }}
            >
                <Newsletter />
            </GridWrapper>

            <SeoLinksHomepage
                py={{
                    base: 'sectionGap',
                    md: 'sectionGapDesktop',
                }}
            />
            <Support />
        </>
    );
};
